/**
 * Failure / recovery explanation contract.
 * Every failure state must answer the six questions below.
 * No fake Undo.
 */

export const FAILURE_EXPLANATION_FIELDS_V0 = [
  'whatHappened',
  'whyItHappened',
  'whatChanged',
  'whatDidNotChange',
  'whatCanHappenNext',
  'receiptOrSupportReference',
] as const;

export type FailureExplanationFieldV0 = (typeof FAILURE_EXPLANATION_FIELDS_V0)[number];

export interface FailureExplanationV0 {
  whatHappened: string;
  whyItHappened: string;
  whatChanged: string;
  whatDidNotChange: string;
  whatCanHappenNext: string;
  receiptOrSupportReference: string;
}

export type RecoveryActionKindV0 =
  | 'retry'
  | 'resume'
  | 'cancel'
  | 'request_compensation'
  | 'open_recovery'
  | 'view_receipt';

export interface RecoveryActionBindingV0 {
  kind: RecoveryActionKindV0;
  labelKo: string;
  /** Must bind to a real supported runtime operation id when actionable. */
  runtimeOperationId: string | null;
  available: boolean;
  fakeUndo: false;
}

export const FAKE_UNDO_FORBIDDEN_V0 = true as const;

export function isCompleteFailureExplanation(value: Partial<FailureExplanationV0>): boolean {
  return FAILURE_EXPLANATION_FIELDS_V0.every((field) => {
    const text = value[field];
    return typeof text === 'string' && text.trim().length > 0;
  });
}

export function assertNoFakeUndo(actions: readonly RecoveryActionBindingV0[]): boolean {
  return actions.every((action) => action.fakeUndo === false);
}
